export default __webpack_public_path__ + "assets/516ee645585ca0f84c999771176b943d.jpeg";